import React, {PropsWithChildren} from 'react';

import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {persistQueryClient} from '@tanstack/react-query-persist-client';
import {createSyncStoragePersister} from '@tanstack/query-sync-storage-persister';
import type {Selectors} from '@/store/selectors/selectors';

const heftyQueries: Array<keyof Selectors> = [
    'getFileWaveformAndDuration',
    'searchEverything',
]
import springboard from 'springboard';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: (query) => {
                return !query.queryKey.some(k => heftyQueries.includes(k as keyof Selectors))
            },
            retry(failureCount, error) {
                return failureCount < 3;
            },
        },
    },
});

if ('localStorage' in globalThis) {
    const localStoragePersister = createSyncStoragePersister({
        storage: globalThis.localStorage,
    })

    // TODO: there was some issue with thr desktop with this
    persistQueryClient({
        queryClient,
        persister: localStoragePersister,
    })
}

springboard.registerModule('ReactQuery', {}, async (moduleAPI) => {
    return {
        Provider: ReactQueryProvider,
    };
});

export const ReactQueryProvider = (props: PropsWithChildren) => {
    return (
        <QueryClientProvider client={queryClient}>
            {props.children}
        </QueryClientProvider>
    );
};
